// src/services/mentor_api.js
import { apiClient } from "./api_client";
import swal from "./swal";

const mentorApi = {
  getMentees: async () => {
    try {
      const response = await apiClient.get("/peer/mentees");
      return response.data;
    } catch (error) {
      console.error("Error retrieving mentees:", error);
      return [
        {
          id: 1,
          name: "John Doe",
          startDate: "2024-05-24",
          stage: "Reality",
          endDate: null,
        },
        {
          id: 2,
          name: "Jane Doe",
          startDate: "2024-05-24",
          stage: "Reality",
          endDate: null,
        },
        {
          id: 3,
          name: "Joe",
          startDate: "2024-05-24",
          stage: "Reality",
          endDate: null,
        },
        {
          id: 4,
          name: "Jill",
          startDate: "2024-05-24",
          stage: "Reality",
          endDate: null,
        },
      ];
      // throw error;
    }
  },
  getPastSessionsWithSummaries: async () => {
    try {
      const response = await apiClient.get("/peer/session-summary");
      return response.data;
    } catch (error) {
      console.error("Error retrieving chat sessions with summaries:", error);
      return [
        {
          id: 5,
          sessionDate: "24.10.31 - 24.11.06",
          userId: 1,
          name: "John Doe",
          summary:
            "- Past Achievement: The user recognized the need to improve team engagement by attempting to explain the importance of the project.\n- Goals Set: The main objective established was to increase team members' motivation and involvement in the project.\n- Realities Faced: The user faced challenges in effectively engaging team members and motivating them to take initiative.\n- Opportunities: Exploring one-on-one conversations to connect team members' contributions to the project goals was considered as a potential solution.\n- Work Plan: The user plans to start one-on-one meetings next week, focusing on active listening and discussing each member's role and goals.",
          suggestion:
            "Based on the summary, it sounds like you are on the right track. Prepare Personalized Questions: \nBefore the one-on-one meetings, consider preparing specific, open-ended questions tailored to each team member. This will encourage deeper conversations about their interests, challenges, and how they see their role contributing to the project's success.",
        },
        {
          id: 6,
          sessionDate: "24.09.15 - 24.09.22",
          userId: 1,
          name: "John Doe",
          summary:
            "- Past Achievement: The user has recognized the need to improve team engagement by attempting to explain the importance of the project.\n- Goals Set: The main objective established was to increase team members' motivation and involvement in the project.\n- Realities Faced: The user faced challenges in effectively engaging team members and motivating them to take initiative.\n- Opportunities: Exploring one-on-one conversations to connect team members' contributions to the project goals was considered as a potential solution.\n- Work Plan: The user plans to start one-on-one meetings next week, focusing on active listening and discussing each member's role and goals.",
          suggestion: "",
        },
      ];
      // throw error;
    }
  },
  sendSuggestion: async (userId, sessionId, suggestion) => {
    console.log("userId:", userId);
    try {
      const response = await apiClient.post("/peer/suggestion", {
        user_id: userId,
        session_id: sessionId,
        suggestion: suggestion,
      });

      const message = response.data.message;

      if (message == "Suggestion was successfully sent") {
        return message;
      } else {
        swal.fire({ icon: "error", text: "Sending suggestion failed" });
        throw new Error("Something went wrong while sending a suggestion");
      }
    } catch (error) {
      console.error("Error retrieving mentees:", error);
      return "Sending suggestion failed";
    }
  },
  getPastSessionsWithSummariesAndSuggestions: async () => {
    try {
      const response = await apiClient.get("/peer/session-suggestion");
      return response.data;
    } catch (error) {
      console.error(
        "Error retrieving chat sessions with summaries and suggestions:",
        error,
      );
      return [
        {
          id: 5,
          sessionDate: "24.09.23 - 24.09.29",
          userId: 1,
          name: "John Doe",
          summary:
            "- Past Achievement: The user recognized the need to improve team engagement by attempting to explain the importance of the project.\n- Goals Set: The main objective established was to increase team members' motivation and involvement in the project.\n- Realities Faced: The user faced challenges in effectively engaging team members and motivating them to take initiative.\n- Opportunities: Exploring one-on-one conversations to connect team members' contributions to the project goals was considered as a potential solution.\n- Work Plan: The user plans to start one-on-one meetings next week, focusing on active listening and discussing each member's role and goals.",
          suggestions: [
            {
              id: 1,
              mentorId: 3,
              mentorName: "Bill Perry",
              suggestion:
                "Based on the summary, it sounds like you are on the right track. Prepare Personalized Questions: \nBefore the one-on-one meetings, consider preparing specific, open-ended questions tailored to each team member. This will encourage deeper conversations about their interests, challenges, and how they see their role contributing to the project's success.",
            },
          ],
        },
        {
          id: 6,
          sessionDate: "24.09.15 - 24.09.22",
          userId: 1,
          name: "John Doe",
          summary:
            "- Past Achievement: The user recognized the need to improve team engagement by attempting to explain the importance of the project.\n- Goals Set: The main objective established was to increase team members' motivation and involvement in the project.\n- Realities Faced: The user faced challenges in effectively engaging team members and motivating them to take initiative.\n- Opportunities: Exploring one-on-one conversations to connect team members' contributions to the project goals was considered as a potential solution.\n- Work Plan: The user plans to start one-on-one meetings next week, focusing on active listening and discussing each member's role and goals.",
          suggestions: [
            {
              id: 2,
              mentorId: 3,
              mentorName: "Bill Perry",
              suggestion:
                "My suggestion is for you to highlight individual strengths. During the meetings, take the opportunity to acknowledge each member's strengths and past contributions. Recognizing their unique value can boost their motivation and willingness to engage more actively.",
            },
            {
              id: 3,
              mentorId: 4,
              mentorName: "Chris Young",
              suggestion:
                "Follow Up Regularly: After the initial one-on-ones, plan for regular check-ins. This will help build trust and show team members that their feedback is being heard and acted upon. It can also help address any ongoing challenges before they become bigger issues.",
            },
            {
              id: 4,
              mentorId: 5,
              mentorName: "James Buxton",
              suggestion:
                "Create Clear Action Items: Ensure that each one-on-one ends with clear, actionable steps for both you and the team member. This can help keep everyone accountable and provide a sense of direction.",
            },
          ],
        },
      ];
    }
  },
};

export default mentorApi;
